export const articles = [
  {
    id: "1",
    title: "流浪地球3",
    category: "movie",
    categoryName: "电影",
    image: "https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20movie%20scene%20with%20giant%20planet%20engines%20on%20Earth%20surface%2C%20epic%20scale%2C%20dramatic%20lighting%2C%20futuristic%20technology%2C%20cinematic%20quality&width=1600&height=900&seq=article-hero-01&orientation=landscape",
    rating: 9.2,
    year: 2026,
    tags: ["科幻", "灾难", "冒险", "国产"],
    director: "郭帆",
    actors: ["吴京", "刘德华", "李雪健"],
    duration: "148分钟",
    updateTime: "2026-08-01",
    summary: `太阳急速老化，持续膨胀，即将吞没整个太阳系。人类在地球表面建造了上万座行星发动机，开启\u201c流浪地球计划\u201d，带着地球去远方寻找新家园。`,
    content: [
      { type: "paragraph", text: "在不久的将来，太阳急速老化，持续膨胀，一百年后将吞没整个太阳系，三百年后太阳系将不复存在。为了应对这场灭顶之灾，世界各国放下芥蒂，成立了联合政府，开启了人类历史上最宏大的工程——流浪地球计划。" },
      { type: "paragraph", text: `人类在地球表面建造了上万座行星发动机，每座发动机高达一万一千米，为地球提供一百五十万亿吨的推力，驱使地球逃离太阳系，前往4.2光年外的新家园——比邻星。这段长达两千五百年的漫长旅程，被称为\u201c流浪地球计划\u201d。` },
      { type: "heading", text: "影片看点" },
      { type: "paragraph", text: "第三部在前两部的基础上，将故事推向了一个全新的高度。人类在漫长的星际旅途中遭遇了前所未有的危机——来自未知星系的外星文明信号、地球发动机的大规模故障、以及人类内部的分裂与冲突。" },
      { type: "paragraph", text: "吴京饰演的刘培强在第二部中牺牲后，其子刘启接过了父亲的责任，成为新一代的领航员。刘德华饰演的图恒宇在本片中也有重大戏份，他的角色将揭示关于数字生命计划更深层的秘密。" },
      { type: "heading", text: "幕后制作" },
      { type: "paragraph", text: "本片历时三年拍摄，特效镜头超过3000个，由中、美、新西兰三国顶尖特效团队联手打造。导演郭帆表示，第三部的特效水准将达到好莱坞A级大片的标准，力求呈现一场前所未有的视觉盛宴。" },
      { type: "paragraph", text: "影片在中国青岛、冰岛、新西兰等多地取景，还搭建了超过10万平方米的实景摄影棚，打造了地下城、空间站、行星发动机内部等震撼场景。" },
    ],
    relatedIds: ["3", "9", "10"],
  },
  {
    id: "2",
    title: "长安三万里2",
    category: "movie",
    categoryName: "电影",
    image: "https://readdy.ai/api/search-image?query=Tang%20Dynasty%20animated%20film%20scene%20with%20ancient%20Chinese%20city%20and%20poets%2C%20golden%20hour%20lighting%2C%20traditional%20architecture%2C%20elegant%20artistic%20style&width=1600&height=900&seq=article-hero-02&orientation=landscape",
    rating: 8.9,
    year: 2026,
    tags: ["动画", "历史", "文化", "国产"],
    director: "追光动画",
    actors: ["配音：杨天翔", "配音：凌振赫"],
    duration: "168分钟",
    updateTime: "2026-07-20",
    summary: "延续第一部的史诗篇章，安史之乱后，长安城满目疮痍。高适与李白在乱世中各自抉择，一首首千古名诗在烽火中诞生。",
    content: [
      { type: "paragraph", text: "天宝十四年，安禄山起兵叛乱，盛世大唐一夜之间天翻地覆。曾经繁华似锦的长安城，转瞬之间变成了战火纷飞的修罗场。这部动画电影以高适的视角，讲述了安史之乱前后那段波澜壮阔的历史。" },
      { type: "paragraph", text: "第二部承接第一部的故事，高适在平定安史之乱中屡立战功，从一个落魄诗人成长为一方节度使。而李白则因卷入永王李璘谋反案，身陷囹圄，流放夜郎。两位挚友在乱世中走向了截然不同的人生道路。" },
      { type: "heading", text: "艺术风格" },
      { type: "paragraph", text: "影片延续了中国传统水墨画与现代CG技术相融合的独特美学风格，画面上既有唐风建筑的恢宏壮丽，又不失诗意的留白与意境。每一帧画面都如同一幅精美的唐代画卷。" },
      { type: "paragraph", text: `片中穿插了多首脍炙人口的唐诗，包括李白的\u300a早发白帝城\u300b、杜甫的\u300a春望\u300b、高适的\u300a别董大\u300b等，通过动画的形式将这些千古名篇背后的故事生动地呈现在观众面前。` },
      { type: "heading", text: "文化意义" },
      { type: "paragraph", text: `这不仅仅是一部动画电影，更是一次对中华传统文化的深情致敬。影片通过高适与李白的友谊，展现了唐代文人\u201c修身齐家治国平天下\u201d的家国情怀，以及他们在乱世中坚守的文化理想。` },
    ],
    relatedIds: ["4", "5", "11"],
  },
  {
    id: "5",
    title: "山河令之风云再起",
    category: "tv",
    categoryName: "电视剧",
    image: "https://readdy.ai/api/search-image?query=Chinese%20martial%20arts%20drama%20scene%20with%20warriors%20in%20ancient%20Chinese%20landscape%2C%20bamboo%20forest%2C%20flowing%20robes%2C%20dramatic%20cinematic%20lighting&width=1600&height=900&seq=article-hero-05&orientation=landscape",
    rating: 8.8,
    year: 2026,
    tags: ["古装", "武侠", "剧情", "国产剧"],
    director: "郑伟文",
    actors: ["肖战", "王一博", "赵丽颖"],
    duration: "40集",
    updateTime: "2026-08-03",
    summary: "江湖风云再起，昔日英雄重出江湖。一场关于武林至尊的争夺在各大门派间悄然展开，恩怨情仇交织，刀光剑影中谁是真正的武林第一？",
    content: [
      { type: "paragraph", text: "江湖，一个永恒的话题。在这片充满刀光剑影的天地间，每个人都有自己的故事。以全新的故事线和更宏大的江湖格局，为观众展开一幅波澜壮阔的武侠画卷。" },
      { type: "paragraph", text: "故事发生在上一部故事的二十年后。昔日的英雄已归隐山林，但江湖从未真正平静。一个神秘的武林至尊令牌重新现世，引发了新一轮的江湖纷争。各大门派明争暗斗，一场血雨腥风在所难免。" },
      { type: "heading", text: "角色介绍" },
      { type: "paragraph", text: "肖战饰演的男主角是一位在深山修炼的年轻剑客，因师父惨死而下山追查真相。王一博则饰演一位神秘组织的首领，亦正亦邪，与男主之间产生了复杂的羁绊。赵丽颖饰演的女主角是一位医术高超的江湖侠女，在旅途中与男主相遇相知。" },
      { type: "heading", text: "制作水准" },
      { type: "paragraph", text: "本剧制作精良，每一场打戏都经过精心设计，融合了传统武术和现代影视特效。全剧在横店、象山、云南等多地取景，每一帧画面都美轮美奂。服装道具更是考究，力求还原最真实的江湖世界。" },
    ],
    relatedIds: ["6", "11", "1"],
  },
  {
    id: "9",
    title: "星辰大海",
    category: "anime",
    categoryName: "动漫",
    image: "https://readdy.ai/api/search-image?query=Futuristic%20space%20anime%20scene%20with%20giant%20mecha%20and%20starship%20battle%2C%20colorful%20nebula%2C%20epic%20sci-fi%20cinematic%20composition&width=1600&height=900&seq=article-hero-09&orientation=landscape",
    rating: 9.1,
    year: 2026,
    tags: ["科幻", "机甲", "冒险", "国产动画"],
    director: "艺画开天",
    actors: ["配音：边江", "配音：季冠霖"],
    duration: "24集",
    updateTime: "2026-08-04",
    summary: "公元2150年，人类文明已经遍布银河系。少年林星在意外中获得一艘远古外星飞船的认可，从此踏上了在浩瀚星海中探索未知文明的征程。",
    content: [
      { type: "paragraph", text: "公元2150年，人类已经迈入了星际文明时代。太阳系内的殖民地遍布各个行星和卫星，而最远的殖民舰队已经抵达了比邻星系。在这个科技高度发达的时代，人类却从未停止对宇宙深处的探索。" },
      { type: "paragraph", text: "少年林星出生在一个偏远的矿业殖民地，原本过着平凡的生活。一次偶然的机会，他在一颗废弃的小行星上发现了一艘来自远古文明的飞船残骸。这艘飞船拥有远超人类科技水平的AI系统，选中了林星作为它的新驾驶员。" },
      { type: "heading", text: "世界观设定" },
      { type: "paragraph", text: "本作构建了一个宏大的科幻世界观。银河系中存在着多个智慧文明，它们之间既有合作也有冲突。人类作为后来者，在星际政治格局中处于弱势地位。而林星发现的那艘远古飞船，则隐藏着改变整个银河系格局的秘密。" },
      { type: "heading", text: "制作特色" },
      { type: "paragraph", text: "每一集的制作预算都达到了国产动画的顶尖水准，太空场景的渲染精度堪比好莱坞科幻大片。机甲设计融合了东方美学与未来科技感，战斗分镜流畅热血，是近年来最值得期待的国产科幻动画。" },
    ],
    relatedIds: ["4", "1", "10"],
  },
  {
    id: "7",
    title: "爆笑家族2",
    category: "variety",
    categoryName: "综艺",
    image: "https://readdy.ai/api/search-image?query=Chinese%20variety%20show%20scene%20with%20celebrities%20playing%20funny%20games%2C%20colorful%20studio%20set%2C%20bright%20lighting%2C%20energetic%20happy%20atmosphere&width=1600&height=900&seq=article-hero-07&orientation=landscape",
    rating: 8.6,
    year: 2026,
    tags: ["搞笑", "家庭", "真人秀", "国产综艺"],
    director: "严敏",
    actors: ["沈腾", "贾玲", "岳云鹏"],
    duration: "12期",
    updateTime: "2026-08-06",
    summary: "国内最火爆的家庭搞笑综艺回归！五组明星家庭在全新的挑战中爆笑连连。",
    content: [
      { type: "paragraph", text: "经过第一季的超高人气和口碑，《爆笑家族》第二季重磅回归！这一季不仅仅是简单的游戏挑战，节目组精心设计了更多元化的环节，包括密室逃脱、厨艺大比拼、户外生存挑战等，让观众能看到明星们最真实、最搞笑的一面。" },
      { type: "heading", text: "本季亮点" },
      { type: "paragraph", text: `本季最大的亮点是新增了\u201c家庭互换\u201d环节，明星家庭需要互换成员生活一周，沈腾去了贾玲家、岳云鹏去了沙溢家……各种意想不到的化学反应让现场笑声不断。` },
      { type: "paragraph", text: `此外，本季还特别设置了\u201c素人家庭\u201d环节，邀请普通观众家庭参与节目录制，与明星家庭同台竞技，让节目更加接地气、更有温度。` },
    ],
    relatedIds: ["8", "12", "6"],
  },
  {
    id: "11",
    title: "大秦帝国之天下",
    category: "tv",
    categoryName: "电视剧",
    image: "https://readdy.ai/api/search-image?query=Chinese%20historical%20war%20epic%20scene%20with%20thousands%20of%20ancient%20soldiers%2C%20Qin%20Dynasty%20aesthetic%2C%20grand%20battle%20formation%2C%20dramatic%20cinematic%20composition&width=1600&height=900&seq=article-hero-11&orientation=landscape",
    rating: 9.3,
    year: 2026,
    tags: ["历史", "战争", "权谋", "国产剧"],
    director: "张黎",
    actors: ["张鲁一", "段奕宏", "李乃文"],
    duration: "58集",
    updateTime: "2026-08-02",
    summary: "秦王嬴政在吕不韦、李斯等人的辅佐下，灭六国、统天下，建立了中国历史上第一个大一统王朝。",
    content: [
      { type: "paragraph", text: `《大秦帝国之天下》是\u201c大秦帝国\u201d系列的终章，讲述了秦王嬴政从亲政到统一六国的完整历程。本剧以严谨的历史考据和宏大的叙事格局，再现了那段改变中国历史走向的壮阔岁月。` },
      { type: "heading", text: "历史还原" },
      { type: "paragraph", text: "制作团队历时两年进行历史考证，从兵器、甲胄到宫殿建筑、礼仪制度，每一个细节都力求还原历史的真实面貌。剧中的战争场面动用了上万名群演，堪称电视剧史上最大规模的战争场景。" },
      { type: "paragraph", text: "在人物塑造上，本剧既展现了嬴政作为千古一帝的雄才大略，也不回避他晚年的迷信与暴虐。吕不韦、李斯、韩非等历史人物也都呈现出丰满立体的形象。" },
    ],
    relatedIds: ["2", "5", "3"],
  },
  {
    id: "4",
    title: "深海传说",
    category: "anime",
    categoryName: "动漫",
    image: "https://readdy.ai/api/search-image?query=Anime%20underwater%20fantasy%20world%20with%20colorful%20coral%20reef%20and%20magical%20creatures%2C%20bioluminescent%20jellyfish%2C%20dreamy%20atmosphere%2C%20beautiful%20animated%20scene&width=1600&height=900&seq=article-hero-04&orientation=landscape",
    rating: 9.0,
    year: 2026,
    tags: ["奇幻", "冒险", "治愈", "国产动画"],
    director: "田晓鹏",
    actors: ["配音：周冬雨", "配音：易烊千玺"],
    duration: "112分钟",
    updateTime: "2026-07-15",
    summary: "少女小渔在一次海难后被神秘力量带入深海世界，发现自己是传说中海之民的后裔。",
    content: [
      { type: "paragraph", text: "《深海传说》是导演田晓鹏继《深海》之后的又一部力作。影片延续了前作绚丽多彩的视觉风格，以更加宏大的海底世界观和更加细腻的情感表达，讲述了一个关于成长与勇气的奇幻故事。" },
      { type: "heading", text: "视觉盛宴" },
      { type: "paragraph", text: `影片中的海底世界堪称一场视觉盛宴。制作团队运用了独创的\u201c粒子水墨\u201d技术，创造出了一个流光溢彩、美轮美奂的深海王国。从发光的珊瑚森林到巨大的鲸鱼之城，每一个场景都充满了想象力。` },
      { type: "paragraph", text: "田晓鹏导演表示，这部电影耗时五年制作，团队人数超过500人，是国产动画电影史上投入最大的项目之一。他希望通过这部电影，让世界看到中国动画的无限可能性。" },
    ],
    relatedIds: ["9", "2", "1"],
  },
];

export const faqs = [
  {
    question: "红桃影视是否需要注册才能观看？",
    answer: "不需要！红桃影视是一个完全免费的在线影视平台，所有资源无需注册、无需登录即可免费观看。我们致力于为用户提供最便捷的观影体验，点击即看，没有任何门槛。",
  },
  {
    question: "红桃影视的视频画质如何？",
    answer: "我们提供1080P超清和4K高清两种画质选择。所有资源均经过专业转码优化，在保证高画质的同时尽可能压缩文件体积，确保用户在不同网络环境下都能流畅观看。",
  },
  {
    question: "观看过程中出现卡顿怎么办？",
    answer: "红桃影视支持多条播放线路自动切换。如果您在观看时遇到卡顿，可以手动切换备用线路，或者稍等片刻让视频缓冲。我们建议在网络状况良好的环境下使用WiFi观看高清内容。",
  },
  {
    question: "红桃影视支持哪些设备观看？",
    answer: "红桃影视完美支持电脑、平板、手机等全平台设备。无论您使用Windows、Mac、iOS还是Android系统，都可以通过浏览器直接访问观看，无需下载任何APP或插件。",
  },
  {
    question: "红桃影视的资源更新速度如何？",
    answer: "我们拥有专业的内容更新团队，热门电影和电视剧通常在首播后24小时内上线。综艺节目力争当天同步更新。您可以在首页的「最新上线」板块找到最新添加的影视资源。",
  },
  {
    question: "红桃影视有广告吗？",
    answer: "红桃影视承诺全程无广告观看体验。与市面上大多数免费影视平台不同，我们不会在视频播放前、播放中或暂停时插入任何形式的广告。您的观影过程干净纯粹，不受任何打扰。",
  },
  {
    question: "如何反馈问题或提出建议？",
    answer: "您可以通过「关于我们」页面的联系方式与我们取得联系，包括电子邮件和在线反馈表单。我们非常重视每一位用户的意见，会在48小时内回复您的反馈。",
  },
];

export const aboutContent = {
  brandIntro: {
    title: "红桃影视 - 让每个人都能享受高品质观影体验",
    paragraphs: [
      "红桃影视成立于2020年，是一家专注于在线影视内容聚合与分发的互联网平台。我们的使命是让每一个热爱影视的人都能轻松、免费地获取到最新、最全的影视资源，无需付费，无需等待，随时随地畅享观影乐趣。",
      "经过多年的发展，红桃影视已经积累了超过10万部影视资源，涵盖电影、电视剧、综艺、动漫等多个品类。我们的内容库每天都在更新，确保用户能第一时间看到最新上线的热门内容。",
      `红桃影视始终坚持\u201c用户至上\u201d的理念，不断优化播放体验和界面设计。我们自主研发的多线路智能切换技术，有效解决了视频播放卡顿的问题，让用户在任何网络环境下都能获得流畅的观影体验。`,
      "未来，红桃影视将继续深耕在线影视领域，引入更多优质内容，提升技术实力，为全球华语用户打造最值得信赖的一站式影视平台。",
    ],
  },
  stats: [
    { label: "影视资源", value: "100,000+", icon: "ri-film-line" },
    { label: "日均用户", value: "500万+", icon: "ri-user-line" },
    { label: "内容品类", value: "20+", icon: "ri-grid-line" },
    { label: "服务年限", value: "6年", icon: "ri-time-line" },
  ],
  values: [
    { title: "免费观影", description: "坚持所有内容免费提供，不设任何付费墙，让每个人都能平等地享受影视文化。", icon: "ri-heart-line" },
    { title: "高清品质", description: "所有资源均提供1080P超清画质，部分内容支持4K播放，追求极致的视觉体验。", icon: "ri-4k-line" },
    { title: "技术驱动", description: "持续投入技术研发，多线路切换、智能转码等核心技术确保播放流畅不卡顿。", icon: "ri-cpu-line" },
    { title: "用户体验", description: "简洁清爽的界面设计，无广告干扰的纯净观影环境，一切以用户感受为先。", icon: "ri-emotion-happy-line" },
  ],
  testimonials: [
    { name: "电影爱好者小李", text: "用了红桃影视三年了，资源更新速度真的快，画质也很棒。最满意的是没有广告，看完一部电影不用等一分钟广告。", rating: 5 },
    { name: "追剧达人王姐", text: "追剧党福音！新剧更新和电视台几乎是同步的，不用到处找资源了。界面简洁，操作也很方便，推荐给了很多朋友。", rating: 5 },
    { name: "动漫迷小张", text: "红桃影视的动漫资源特别全，国漫日漫都有。而且画质是真的好，大屏幕看特别爽。最重要的是完全免费！", rating: 5 },
  ],
  contact: {
    email: "contact@hongtaomovies.com",
    feedbackEmail: "feedback@hongtaomovies.com",
    wechat: "红桃影视官方",
    weibo: "@红桃影视",
    hours: "周一至周日 9:00 - 21:00",
  },
};